import {Component} from "react";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import {withRouter} from 'react-router-dom'
import React from "react";
import {Avatar, Card, Row, Col} from "antd";
import {setEditMyAccountVisible} from "../../actions/AppAction";

export class DashboardMyAccount extends Component {
  goToAssets = (e) => {
    e.preventDefault()
    this.props.setEditMyAccountVisible(true)
  };

  render() {
    const hash = '#';

    const {
      user,
      intl
    } = this.props

    const role = user.role === 'admin' && user.clientRole === 'admin'
      ? 'Súper admin'
      : user.clientRole === 'admin' ? 'Administrador' : 'Operador';

    return (
      <React.Fragment>
        <Card className="dashboard-my-account" title={intl.formatMessage({id: 'my_account'})} extra={(
          <a href={hash} onClick={this.goToAssets}>
            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.5361 2.33188C10.8392 0.513713 13.5756 0.285597 15.6778 1.81988C17.532 3.62756 17.7629 6.34708 16.1967 7.92914L8.49177 17.0977C8.10763 17.5766 7.56773 17.9113 6.94009 18.0597L2.40716 19.1012C2.05898 19.2072 1.65 19.1105 1.33827 18.8486C1.02654 18.5866 0.860906 18.2004 0.905379 17.8392L1.1508 13.1946C1.19532 12.553 1.43142 11.9652 1.83122 11.5004L9.5361 2.33188ZM5.19794 14.2672C5.67279 14.6663 6.64667 14.289 7.37315 13.4245L13.4416 6.2032C13.795 5.78897 14.0428 5.31224 14.1286 4.88137C14.2144 4.45051 14.131 4.10211 13.8972 3.91536C13.4224 3.51632 12.4485 3.89364 11.722 4.75813L5.65356 11.9794C4.92708 12.8439 4.72309 13.8682 5.19794 14.2672Z" fill="#3598CD"/>
            </svg>
          </a>
        )} hoverable
              >
                {/* style={{minHeight: "295px"}} */}
          <Row gutter={25} style={{marginTop: "30px"}}>
            <Col md={9} xs={24} span={9}>
              <Avatar size={159} src={user.avatar}
                      style={{border: '2px solid #3598CD', background: "#E7F6FF"}}/>
            </Col>
            <Col md={15} xs={24} span={15}>
              <div style={{textAlign: 'left'}}>
                <p><b>{intl.formatMessage({id: 'name'})}</b>: {user.name}</p>
                <p><b>{intl.formatMessage({id: 'email'})}</b>: {user.email}</p>
                <p><b>{intl.formatMessage({id: 'role'})}</b>: {role}</p>
                <p><b>{intl.formatMessage({id: 'login_password'})}</b>: ********</p>
              </div>
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    );
  }
}

const mapStateToProps = () => {
  return {
  }
};

const mapDispatchToProps = {
  setEditMyAccountVisible
};

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardMyAccount)))
